module.exports = __webpack_public_path__ + "html/wave-header_d1c7c1990bfcb9816bd2976022f97b7e.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 154